<template>
    <div class="header-user" v-if="user">
        <div class="header-user__face" @click="isActive = !isActive">
            <div class="header-user__img">
                <img :src="user.profileimageurlsmall">
            </div>
            <div class="header-user__name">{{ user.fullname }}</div>
            <svg class="header-user__icon header-user__icon_size_s">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-arrow-down"></use>
            </svg>
        </div>
        <div class="header-user__content" v-if="isActive">
            <h3 class="header-user__title">{{ `${user.fullname}` }}</h3>
            <div class="header-user__mail">{{ user.email }}</div>
            <Lang class="header-user__lang"/>
            <div class="header-user__list">
                <btn-wrapper
                    v-for="(item, index) in array"
                    type = 'link'
                    :to="item.path"
                    class = 'link header-user__row hover:bg-default/10 group'
                    :class="{'header-user__item_inactive' : item?.inactive}"
                    :key="`user-header-btn-${index}`"
                >
                    <svg class="header-user__icon">
                        <use :xlink:href="item.icon"></use>
                    </svg>
                    <div class="header-user__item group-hover:text-default">{{ item.text }}</div>
                </btn-wrapper>

                <btn-wrapper type="div" class="link header-user__row" @click="clearCache">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="header-user__icon"
                         width="48.117px" height="48.117px" viewBox="0 0 48.117 48.117"
                    >
                        <g>
                            <path d="M30.621,4.122c-2.995-1.345-6.206-2.018-9.418-2.018c-2.651,0-5.295,0.482-7.826,1.399L10.76,0.586 C9.918-0.352,8.919-0.141,8.529,1.058L4.014,14.88c-0.391,1.196,0.291,1.955,1.523,1.697l14.228-3 c1.232-0.261,1.55-1.232,0.708-2.167L18.49,9.198c3.13-0.532,6.379-0.16,9.33,1.165c3.938,1.769,6.951,4.962,8.485,8.998   c1.535,4.033,1.405,8.423-0.362,12.36c-1.767,3.938-4.962,6.951-8.997,8.485c-4.033,1.532-8.424,1.405-12.361-0.36   c0,0-0.627,1.396-1.401,3.121c-0.774,1.721,0.46,4.006,2.914,4.571c4.39,1.008,8.978,0.699,13.281-0.936 c5.743-2.188,10.291-6.478,12.807-12.08c2.516-5.604,2.699-11.854,0.514-17.596C40.516,11.185,36.226,6.637,30.621,4.122z"/>
                        </g>
                    </svg>
                    <div class="header-user__item">{{ $t('headerMenu.cache') }}</div>
                </btn-wrapper>
            </div>
            <btn-wrapper data-testid="user-block-logout-btn" :label="$t('headerMenu.exit')" class= 'header-user__button' @click="logoutAction">
                <svg class="header-user__icon header-user__icon_color_red">
                    <use xlink:href="/img/sprites/icons-sprite.svg#icon-out"></use>
                </svg>
            </btn-wrapper>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Lang from './Lang.vue'
import db from '@/database'
import BtnWrapper from "@/components/UI/BtnWrapper.vue";
import * as Sentry from "@sentry/vue";

export default {
    name: 'HeaderUser',
    components: {
        BtnWrapper,
        Lang
    },
    data: () => ({
        isActive: false,
    }),
    mounted() {
        document.addEventListener('click', this.closeDropDown)
    },
    unmounted() {
        document.removeEventListener('click', this.closeDropDown)
    },
    watch: {
        $route() {
            this.isActive = false;
        }
    },
    methods: {
        ...mapActions(['logout', 'deleteTokenWhenUserLogout']),
        async logoutAction() {
            try {
                await this.logout()
                Sentry.endSession()
            } catch (err) {
                console.log('Logout:', err)
            } finally {
                // this.$router.push('/home')
                window.location.href = '/home'
            }
        },
        closeDropDown({target}) {
            if (!target.closest('.header-user')) {
                this.isActive = false;
            }
        },
        clearCache() {
            const email = localStorage.getItem('user_email')
            localStorage.clear()
            localStorage.setItem('user_email',email)
            db.clearCache().then(() => {
                document.location.reload()
            }).catch(() => {
                document.location.reload()
            })
        }
    },
    computed: {
        ...mapGetters(['user']),
        array() {
            return [{
                icon: '/img/sprites/icons-sprite.svg#icon-man',
                text: this.$t('headerMenu.profile'),
                path: '/profile'
            },
                {
                    icon: '/img/sprites/icons-sprite.svg#icon-estimates',
                    text: this.$t('headerMenu.grades'),
                    path: '/rating'
                },
                {
                    text: this.$t('headerMenu.badges'),
                    icon: '/img/sprites/icons-sprite.svg#shield',
                    path: '/badges'
                }
                // {
                //     icon: '/img/sprites/icons-sprite.svg#icon-message',
                //     text: this.$t('headerMenu.messages'),
                //     path: '#',
                //     inactive: true
                // },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/header-user.scss';
</style>
